module.exports = __webpack_public_path__ + "img/ag.9ed0c82a.svg";